// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".count[data-v-1785dc36]{width:65%;min-width:62.5rem;margin:0 auto;display:flex;border:.052083rem solid #ccc}.count .count_btn[data-v-1785dc36]{margin:.520833rem auto}.HighwayCalculation[data-v-1785dc36],.RailwayCalculation[data-v-1785dc36]{margin:.729167rem auto}", ""]);
// Exports
module.exports = exports;
